module.exports = __webpack_public_path__ + "static/img/yggh-1.192721f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/employee-care/yggh-1.jpg
// module id = nCFT
// module chunks = 2